<template>
  <div
    :class="[rootClass, { [`${rootClass}--image`]: showLogo }]"
    :aria-hidden="decorative ? 'true' : undefined"
  >
    <img
      v-if="showLogo"
      :src="logoSrc"
      :alt="decorative ? '' : altText"
      loading="lazy"
      @error="imageFailed = true"
    />
    <span v-else>{{ initial }}</span>
  </div>
</template>

<script>
export default {
  name: 'JobCompanyLogo',
  props: {
    companyName: { type: String, default: '' },
    logoUrl: { type: String, default: '' },
    rootClass: { type: String, required: true },
    decorative: { type: Boolean, default: true },
  },
  data() {
    return { imageFailed: false };
  },
  computed: {
    logoSrc() {
      if (!this.logoUrl) return '';
      return this.$S3_url + this.logoUrl;
    },
    showLogo() {
      return Boolean(this.logoUrl) && !this.imageFailed;
    },
    initial() {
      const name = this.companyName || 'J';
      return name.charAt(0).toUpperCase();
    },
    altText() {
      return this.companyName ? `${this.companyName} logo` : 'Company logo';
    },
  },
  watch: {
    logoUrl() {
      this.imageFailed = false;
    },
  },
};
</script>
